import { useAuth0 } from '@auth0/auth0-react';
import { datadogRum } from '@datadog/browser-rum';
import { getApiUrl } from 'src/shared/lib/getApiUrl';
import mixpanel from 'src/shared/lib/mixpanel';

type ErrorProps = {
  message: string;
  title: string;
  component?: string;
};

export function useErrorLogger() {
  const { getAccessTokenSilently } = useAuth0();

  async function reportCrash(error: Error, { message, title, component }: ErrorProps) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Local Crash detected', error);
      return;
    }
    const activeSession = datadogRum.getInternalContext();

    const token = await getAccessTokenSilently();
    fetch(`${getApiUrl()}/api/v2/report_crash`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        title: title,
        component: component,
        path: window.location.href,
        error: error.name + ': ' + error.message,
        rumId: activeSession?.session_id,
        // stack: error.stack,
        message: message,
      }),
    });
    if (component) {
      mixpanel.track('Component Crashed', {
        error,
        component,
      });
      datadogRum.addError(error, {
        tags: 'component-error',
      });
    } else {
      mixpanel.track('Fatal Crash', error);
      datadogRum.addError(error, {
        tags: 'fatal-error',
      });
    }
  }

  return { reportCrash };
}
